import * as React from "react";

import {SkeletonAccordionBodyItem} from "./skeletonAccordionBodyItem";

export const SkeletonAccordionBody = () => {
    return (
        <>
            <SkeletonAccordionBodyItem/>
            <SkeletonAccordionBodyItem/>
            <SkeletonAccordionBodyItem/>
            <SkeletonAccordionBodyItem/>
            <SkeletonAccordionBodyItem/>
        </>
    );
}